import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function formatPhoneNumber(phoneNumber: string | undefined | null): string {
  // Remove any non-digit characters except +
  // Coerce to string to handle undefined/null inputs from minified call sites
  const cleaned = String(phoneNumber ?? '').replace(/[^\d+]/g, '');
  
  // Handle US/Canada numbers (+1)
  if (cleaned.startsWith('+1') && cleaned.length === 12) {
    const digits = cleaned.substring(2);
    return `+1 (${digits.substring(0, 3)}) ${digits.substring(3, 6)}-${digits.substring(6)}`;
  }
  
  // Handle UK numbers (+44)
  if (cleaned.startsWith('+44') && cleaned.length >= 11) {
    const digits = cleaned.substring(3);
    if (digits.length === 10) {
      return `+44 ${digits.substring(0, 4)} ${digits.substring(4, 7)} ${digits.substring(7)}`;
    }
  }
  
  // Handle other international numbers with basic formatting
  if (cleaned.startsWith('+') && cleaned.length > 7) {
    const countryCode = cleaned.substring(0, cleaned.length - 10);
    const number = cleaned.substring(cleaned.length - 10);
    return `${countryCode} ${number.substring(0, 3)} ${number.substring(3, 6)} ${number.substring(6)}`;
  }
  
  // Fallback to original number if no formatting rules apply
  return phoneNumber;
}
